import { Box, Divider, Stack } from '@mui/material'
import ButtonSmall from '../../../shared/UI/ButtonSmall'
import Paragraph from '../../../shared/UI/Paragraph'

type Props = {
  color: string
  type: string
  value: string | undefined
  divider?: boolean
  showLink?: boolean
  linkLabel?: string
  url?: () => void
  dataTestId?: string
}

function LegendItem({
  color,
  type,
  value = '0.00/0.00',
  divider,
  showLink,
  linkLabel,
  url,
  dataTestId,
}: Props) {
  return (
    <>
      <Stack direction="row" alignItems="center" gap={2} sx={{ gridColumn: 1 }}>
        <Box sx={{ background: color, borderRadius: '4px', minWidth: 15, width: 15, height: 15 }} />
        <Paragraph weight="bold">{type}</Paragraph>
      </Stack>

      <Box sx={{ gridColumn: 2, display: 'flex', justifyContent: 'center' }}>
        {showLink && (
          <ButtonSmall
            label={linkLabel}
            onClick={url}
            sx={{ lineHeight: '18px', minWidth: '60px', margin: 0 }}
            dataTestId={dataTestId}
          />
        )}
      </Box>

      <Box sx={{ gridColumn: 3, textAlign: 'right' }}>
        <Paragraph sx={{ whiteSpace: 'nowrap' }}>{value}</Paragraph>
      </Box>

      <Divider sx={{ gridColumn: '1 / -1', margin: '10px 0px', display: divider ? 'visible' : 'none' }} />
    </>
  )
}

export default LegendItem
